import { Link } from "react-router-dom";
import { ShieldCheck, Phone, MapPin } from "lucide-react";

export default function Footer() {
    return (
        <footer
            className="bg-[#F5F2EA] border-t border-[#E3DCC8] mt-24"
            data-testid="site-footer"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
                <div className="grid md:grid-cols-3 gap-12">
                    <div>
                        <h3 className="font-heading text-2xl text-[#2C332A] tracking-tight">
                            Present Day
                        </h3>
                        <p className="text-sm tracking-widest text-[#5B6358] mt-1">
                            COUNSELING &amp; RECOVERY
                        </p>
                        <p className="text-[#5B6358] mt-6 leading-relaxed max-w-sm">
                            Compassionate, collaborative therapy for teens and
                            adults navigating addiction, anxiety, and life's
                            transitions.
                        </p>
                    </div>

                    <div>
                        <h4 className="font-heading text-sm uppercase tracking-[0.2em] text-[#2C332A]">
                            Explore
                        </h4>
                        <ul className="mt-5 space-y-3">
                            {[
                                { to: "/", label: "Home" },
                                { to: "/about", label: "About Ray" },
                                { to: "/services", label: "Services" },
                                {
                                    to: "/consultation",
                                    label: "Book a Consultation",
                                },
                            ].map((l) => (
                                <li key={l.to}>
                                    <Link
                                        to={l.to}
                                        className="text-[#5B6358] hover:text-[#2C332A] transition-colors"
                                        data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                                    >
                                        {l.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div>
                        <h4 className="font-heading text-sm uppercase tracking-[0.2em] text-[#2C332A]">
                            Contact
                        </h4>
                        <ul className="mt-5 space-y-4 text-[#5B6358]">
                            <li>
                                <a
                                    href="tel:4052540805"
                                    className="inline-flex items-center gap-3 hover:text-[#2C332A] transition-colors"
                                    data-testid="footer-phone-link"
                                >
                                    <Phone className="w-4 h-4 text-[#8C9C88]" />
                                    405-254-0805
                                </a>
                            </li>
                            <li className="inline-flex items-start gap-3">
                                <ShieldCheck className="w-4 h-4 mt-0.5 text-[#8C9C88] shrink-0" />
                                <span className="text-sm leading-relaxed">
                                    All sessions are strictly confidential.
                                    Your story is safe here.
                                </span>
                            </li>
                            <li className="inline-flex items-start gap-3">
                                <MapPin className="w-4 h-4 mt-0.5 text-[#8C9C88] shrink-0" />
                                <span className="text-sm leading-relaxed">
                                    Teens &amp; adults welcome
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-12 pt-8 border-t border-[#E3DCC8] flex flex-col sm:flex-row justify-between gap-3 text-sm text-[#5B6358]">
                    <p>
                        © {new Date().getFullYear()} Present Day Counseling and
                        Recovery. All rights reserved.
                    </p>
                    <p>Ray Smith, LPC, Therapist · she/her</p>
                </div>
            </div>
        </footer>
    );
}
